package com.sddamico.draftmachine.models

import kotlinx.serialization.Serializable

/** Frontend mirrors of the jvmMain `api/auth/AuthModels.kt` DTOs (same JSON shape). */

@Serializable
data class SendOtpRequest(val email: String)

@Serializable
data class VerifyRequest(val email: String, val code: String)

@Serializable
data class MeResponse(val id: String, val email: String, val username: String)

@Serializable
data class UpdateUsernameRequest(val username: String)

@Serializable
data class ConsumeMagicLinkRequest(
  val token: String,
  val confirmSwitch: Boolean = false,
  val pushEndpoint: String? = null,
)

@Serializable
data class LogoutRequest(val pushEndpoint: String? = null)

@Serializable
data class ConsumeMagicLinkResponse(
  val email: String,
  val destination: String,
  val switchRequired: Boolean = false,
)

@Serializable
data class ReplaceMagicLinkRequest(val token: String)
